import { takeEvery, put, call } from "redux-saga/effects";

import { CREATE_PN_TEMPLATE, PN_TEMPLATE, REMOVE_PN_TEMPLATE, UPDATE_PN_TEMPLATE } from "./actionTypes";

import {
  createProgressNoteTempFail,
  createProgressNoteTempSuccess,
  progressNoteTempListFail,
  progressNoteTempListSuccess,
  removeProgressNoteTempListFail,
  removeProgressNoteTempListSuccess,
  updateProgressNoteTempFail,
  updateProgressNoteTempSuccess,
} from "./actions";

import {
  onGetProgressNoteTemplates,
  onCreateProgressNoteTemplates,
  onUpdateProgressNoteTemplates,
  onRemoveProgressNoteTemplates,
} from "helpers/fakebackend_helper";

import { responseHandler } from "common/CommanFunction";
import showToast from "common/Notification";

const title = "Progress Note Template";

function* onGet({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGetProgressNoteTemplates, data);
    yield call(responseHandler, title, response, progressNoteTempListSuccess, progressNoteTempListFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(progressNoteTempListFail(error));
    showToast("error", title, error);
  }
}

function* onCreate({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onCreateProgressNoteTemplates, data);
    yield call(responseHandler, title, response, createProgressNoteTempSuccess, createProgressNoteTempFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(createProgressNoteTempFail(error));
    showToast("error", title, error);
  }
}

function* onUpdate({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onUpdateProgressNoteTemplates, data);
    yield call(responseHandler, title, response, updateProgressNoteTempSuccess, updateProgressNoteTempFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(updateProgressNoteTempFail(error));
    showToast("error", title, error);
  }
}

function* onRemove({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onRemoveProgressNoteTemplates, data);
    yield call(responseHandler, title, response, removeProgressNoteTempListSuccess, removeProgressNoteTempListFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(removeProgressNoteTempListFail(error));
    showToast("error", title, error);
  }
}

export function* ProgressNoteSaga() {
  yield takeEvery(PN_TEMPLATE, onGet);
  yield takeEvery(REMOVE_PN_TEMPLATE, onRemove);
  yield takeEvery(CREATE_PN_TEMPLATE, onCreate);
  yield takeEvery(UPDATE_PN_TEMPLATE, onUpdate);
}

export default ProgressNoteSaga;
